module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-sengkang/key-1-2015.svg?v=3e3204f5";